export default __webpack_public_path__ + "static/media/AdvanceBoardPiece.4176bcba.mp3";